import { Message } from 'element-ui'
import axios from 'axios'

axios.defaults.baseURL = process.env.BASE_API
axios.defaults.timeout = 10000
axios.defaults.withCredentials = true

// 错误信息处理
const errorHandle = (status, other) => {
  switch (status) {
    case 400:
      console.log('信息验证失败')
      break
    case 401:
      Message.error('请重新登录！')
      // this.$router.push('/login')
      break
    case 403:
      Message.error('权限已更改,请重新登录！')
      console.log('token校验失败')
      break
    case 404:
      Message.error('请检查请求接口是否正确！')
      break
    case 405:
      Message.error('接口请求方式不允许！')
      break
    default:
      Message.error('请求失败')
      console.log(other)
      break
  }
}
// 添加请求拦截器
axios.interceptors.request.use((config) => {
  return config
}, (error) => {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use((response) => {
  // 对响应数据做点什么
  if (response.status === 200 && response.data.code !== 0) {
    Message.error(response.data.msg)
  }
  return response.status === 200 ? Promise.resolve(response.data) : Promise.reject(response)
}, (error) => {
  // 对响应错误做点什么
  const data = error.response
  if (data) {
    errorHandle(data.status, data.message)
    return Promise.reject(data)
  } else {
    Message.error('响应超时')
  }
})
export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.js